import logger from '../utils/logger';
import api from '../config/api';

// Helper: identify subscription 402 so we can suppress noisy error logs
const isSubscriptionBlock = (error) => {
    const status = error?.response?.status;
    const type = error?.response?.data?.errorType;
    return status === 402 && type === 'SUBSCRIPTION_REQUIRED';
};

export const analyticsService = {
    async getTodayKPIs(shopId) {
        try {
            const response = await api.get(`/analytics/${shopId}/kpis/today`);
            return { success: true, data: response.data };
        } catch (error) {
            if (!isSubscriptionBlock(error)) {
                logger.error('Failed to fetch today KPIs:', error);
            }
            return { success: false, error: error.response?.data?.message || 'Failed to fetch KPIs' };
        }
    },

    async getRecentOrders(shopId, limit = 10) {
        try {
            const response = await api.get(`/orders/${shopId}/recent?limit=${limit}`);
            return { success: true, data: response.data };
        } catch (error) {
            logger.error('Failed to fetch recent orders:', error);
            return { success: false, error: error.response?.data?.message || 'Failed to fetch recent orders' };
        }
    },

    async getTableStatus(shopId) {
        try {
            const response = await api.get(`/tables/${shopId}/status`);
            return { success: true, data: response.data };
        } catch (error) {
            logger.error('Failed to fetch table status:', error);
            return { success: false, error: error.response?.data?.message || 'Failed to fetch table status' };
        }
    },

    async getWeeklySales(shopId, from, to) {
        try {
            const response = await api.get(`/analytics/${shopId}/sales?from=${from}&to=${to}`);
            return { success: true, data: response.data };
        } catch (error) {
            if (!isSubscriptionBlock(error)) {
                logger.error('Failed to fetch weekly sales:', error);
            }
            return { success: false, error: error.response?.data?.message || 'Failed to fetch weekly sales' };
        }
    },

    async getTopProducts(shopId, days = 7, limit = 5) {
        try {
            const response = await api.get(`/analytics/${shopId}/top-products?days=${days}&limit=${limit}`);
            return { success: true, data: response.data };
        } catch (error) {
            if (!isSubscriptionBlock(error)) {
                logger.error('Failed to fetch top products:', error);
            }
            return { success: false, error: error.response?.data?.message || 'Failed to fetch top products' };
        }
    },

    async getAverageOrderValue(shopId, days = 7) {
        try {
            const response = await api.get(`/analytics/${shopId}/aov?days=${days}`);
            return { success: true, data: response.data };
        } catch (error) {
            if (!isSubscriptionBlock(error)) {
                logger.error('Failed to fetch average order value:', error);
            }
            return { success: false, error: error.response?.data?.message || 'Failed to fetch AOV' };
        }
    },

    async getPaymentStatus() {
        try {
            const response = await api.get('/payments/stripe/status');
            return { success: true, data: response.data };
        } catch (error) {
            logger.error('Failed to fetch payment status:', error);
            return { success: false, error: error.response?.data?.message || 'Failed to fetch payment status' };
        }
    }
};

export default analyticsService;
